import {Text, TouchableOpacity, View} from '@/components/react-native';
import {INoteInfo} from '@/types/airport';

interface NoteDetailHeaderProps {
  item: INoteInfo;
  onClose: () => void;
  onSave: () => void;
}

const ChevronLeftIcon = () => (
  <svg width={21} height={20} viewBox="0 0 21 20" fill="none">
    <path
      d="M13 15L8 10L13 5"
      stroke="#E7E5E4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CloseIcon = () => (
  <svg width={28} height={28} viewBox="0 0 28 28" fill="none">
    <path
      d="M21 7L7 21M7 7l14 14"
      stroke="#E7E5E4"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NoteDetailHeader = ({
  item,
  onClose,
  onSave
}: NoteDetailHeaderProps) => {
  return (
    <View className="h-[48px] flex-row items-center justify-between px-0 pr-[4px]">
      <View className="flex-row items-center">
        <TouchableOpacity
          onPress={onClose}
          className="flex-row items-center gap-[6px] pl-[16px] pr-0 py-[12px] rounded-lg"
        >
          <ChevronLeftIcon />
          <Text
            fontFamily="Geist"
            className="text-[#FAFAF9] text-[16px] font-[500] leading-[20px]"
          >
            {item?.approved_by ? 'Note' : 'Review Note'}
          </Text>
        </TouchableOpacity>
      </View>
      {!item?.approved_by ? (
        <TouchableOpacity
          onPress={onSave}
          className="bg-[#38BDF8] rounded-[6px] px-[14px] py-[12px] mr-[16px]"
        >
          <Text
            fontFamily="Geist"
            className="text-[#1C1917] text-[16px] font-[500] leading-[20px]"
          >
            Save and Exit
          </Text>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          onPress={onClose}
          className="p-[6px] rounded-[9999px]"
        >
          <CloseIcon />
        </TouchableOpacity>
      )}
    </View>
  );
};
